
import { Component, Prop, Vue } from 'vue-property-decorator';
import Alert from '~/components/Alerts/Alert.vue';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import HiddenInput from '~/components/Inputs/HiddenInput.vue';
import SelectInput from '~/components/Inputs/Select.vue';
import TextInput from '~/components/Inputs/Text.vue';
import { reinitiateMicroDeposits, sendBankDeposits } from '@/api/account';
import { validateDigitLength, validateDigitMaxLength } from '@/utils/validators';

function generateMask(options: Record<string, unknown>) {
  return {
    showMaskOnHover: false,
    jitMasking: true,
    ...options
  };
}

@Component({
  components: {
    Alert,
    CustomButton,
    HiddenInput,
    SelectInput,
    TextInput
  }
})
export default class BankDetails extends Vue {
  @Prop(Boolean) readonly hideInputs!: boolean;

  accountTypes = [
    { text: 'Checking', value: 'checking' },
    { text: 'Savings', value: 'savings' }
  ];

  bankMask = generateMask({
    noValuePatching: false,
    autoUnmask: true,
    mask: '99999999999999999',
  });

  routingNumberMask = generateMask({
    noValuePatching: true,
    mask: '999999999',
  });

  bankAccountType = '';

  bankAccountNumber = '';

  bankAccountVerification = '';

  routingNumber = '';

  loading = false;

  validForm = false;

  showError = false;

  get bankAccountRules() {
    return [(val: string) => validateDigitLength(val, 3, 17) || 'Please enter a valid bank account number.'];
  }

  get bankAccountTypeRules() {
    return [(val: string) => !!val || 'Select a Bank Account type'];
  }

  get routingNumberRules() {
    return [(val: string) => validateDigitMaxLength(val, 9) || 'Please enter a valid 9-digit routing number.'];
  }

  get bankVerificationRules() {
    return [(val: string) => val === this.bankAccountNumber || 'Bank Account doesn\'t match'];
  }

  get buttonDisabled() {
    return this.loading || !this.validForm;
  }

  async sendDeposits() {
    this.loading = true;
    try {
      if (this.hideInputs) {
        await reinitiateMicroDeposits();
      } else {
        await sendBankDeposits({
          bank_account_type: this.bankAccountType,
          ach_account_number: this.bankAccountNumber,
          ach_routing_number: this.routingNumber
        });
      }
      if (!this.$store.getters['Account/hasBankDetails']) {
        await this.$store.dispatch('Account/getBankDetails');
      }
      this.$emit('success');
    } catch {
      this.showError = true;
    } finally {
      this.loading = false;
    }
  }
}
